import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data-test-id", "flush", "layout", "maxWidth", "primaryContent", "reverseOrder", "secondaryContent", "secondaryContentWidth", "titleText"];
import styled from 'styled-components';
import { Text } from '../../../components/Text/Text';
import { Box } from '../Box';
import { useTheme } from 'styled-components';
import { filterProps } from '../../../utils';
import { useMapStylePropsToCSS } from '../../../hooks/useMapStylePropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const toPx = value => typeof value === 'number' ? `${value}px` : value;
const Outer = styled.div.withConfig({
  displayName: "EmptyState__Outer",
  componentId: "sc-1ssjkah-0"
})(props => {
  const theme = props.theme;
  const isVertical = props.$layout === 'vertical';
  const cssStyles = props.$cssStyles;
  return Object.assign({
    margin: `${isVertical ? theme.space['1000'] : `calc(2 * ${theme.space['1000']})`} auto`,
    display: 'block',
    marginBottom: props.$flush ? theme.space['0'] : undefined,
    marginTop: props.$flush ? theme.space['0'] : undefined,
    paddingInline: theme.space['1200'],
    maxWidth: toPx(props.$maxWidth),
    width: '100%'
  }, cssStyles);
});
const Inner = styled.div.withConfig({
  displayName: "EmptyState__Inner",
  componentId: "sc-1ssjkah-1"
})(props => {
  const theme = props.theme;
  return {
    marginLeft: `-${theme.space['1200']}`,
    marginTop: `-${theme.space['500']}`,
    display: 'flex',
    flexDirection: props.$direction,
    flexWrap: 'wrap',
    textAlign: props.$direction === 'column' ? 'center' : 'left'
  };
});
export const EmptyState = _ref => {
  let {
      'data-test-id': dataTestId,
      flush = false,
      layout = 'horizontal',
      maxWidth = 815,
      primaryContent,
      reverseOrder = false,
      secondaryContent,
      secondaryContentWidth = 350,
      titleText
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    styleProps,
    domProps
  } = filterProps(restProps, {
    labelable: true
  });
  const cssStyles = useMapStylePropsToCSS(styleProps);
  const theme = useTheme();
  const computedPadding = parseInt(theme.space['1200'], 10);
  const computedSecondaryContentWidth = secondaryContentWidth + computedPadding;
  const computedPrimaryContentWidth = secondaryContent ? parseInt(theme.space['1700'], 10) + computedPadding : '100%';
  const title = typeof titleText === 'string' ? /*#__PURE__*/_jsx(Text, {
    as: "h4",
    children: titleText
  }) : titleText;
  return /*#__PURE__*/_jsx(Outer, Object.assign({
    $flush: flush,
    $layout: layout,
    $maxWidth: maxWidth,
    $cssStyles: cssStyles,
    "data-test-id": dataTestId
  }, domProps, {
    children: /*#__PURE__*/_jsxs(Inner, {
      $direction: layout === 'vertical' ? 'column' : 'row',
      children: [/*#__PURE__*/_jsxs(Box, {
        flexDirection: "column",
        order: reverseOrder ? 1 : 0,
        paddingInlineStart: "1200",
        paddingBlockStart: "500",
        basis: layout === 'horizontal' ? computedPrimaryContentWidth : 'auto',
        flexGrow: 9999,
        children: [titleText && title, primaryContent]
      }), secondaryContent && /*#__PURE__*/_jsx(Box, {
        order: reverseOrder ? 0 : 1,
        paddingBlockStart: "500",
        paddingInlineStart: "1200",
        basis: computedSecondaryContentWidth,
        flexGrow: 1,
        children: secondaryContent
      })]
    })
  }));
};